module.exports = __webpack_public_path__ + "images/maasleasing412eb82e6e84f558db19580269f7a341.png";